import axios from "axios";
import { useForm } from "react-hook-form";
import { Notyf } from "notyf";
import { API_BASE_URL } from "../../../config/config";
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";



export default function SignIn() {

  const [showPassword, setShowPassword] = useState(false);

const notyf = new Notyf({
    dismissible: true, ripple: false,
    duration: 1000,
    position: { x: 'rigth', y: 'top' },
    types: [
      {
        type: 'warning',
        background: 'orange',
        icon: { className: 'material-icons', tagName: 'i', text: 'warning' }
      },
      {
        type: 'error',
        background: 'indianred',
        duration: 3000,
        dismissible: true
      }
    ]
  });

    const { register, handleSubmit, reset } = useForm();
//   const notyf = new Notyf();

 const onSubmit = async (data) => {
    try {
      const response = await axios.post( `${API_BASE_URL}/auth/signin` ,
        {
          email: data.email,
          password: data.password,
        
        },
  {
    withCredentials: true, 
    headers: {
      "Content-type":"application/json"
    }
  }
      );

      if (response.status === 200) {
        const user = response.data;
        console.log(user)
        window.location.href=("/");
        notyf.success('Vous êtes connecté !');
        // Stockage local (sans le token qui est en cookie HttpOnly)
        sessionStorage.setItem('useremail', data.email);
        
        // Redirection ou rechargement si besoin
        setTimeout(() => {
          notyf.success('Vous êtes connecté !');
        }, 2000);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401 || error.response.status === 404) {
          notyf.error('Identifiants invalides');
        } else {
          notyf.error(`Erreur serveur : ${error.response.statusText}`);
        }
      } else {
        notyf.error('Erreur réseau ou serveur injoignable');
      }

      console.error(error);
    }
};


    return (
        <>
        
          
            <div className="mx-auto max-w-screen-md mt-aut text-center mb-8 lg:mb-12">
              <p className="mb-5  mt-20 text-gray-600  dark:text-gray-400">Connectez-vous pour retrouver vos favoris et bénéficier d'une expérience personnalisée.</p>
            </div>

            <div className="flex mtCGfreeUniv -mt-10 mb-20 text-center content-center justify-center p-2 py-6  ">
              
                <div className="">
                    {/* ////////// */}

                    {/* /////// */}
                   

                    <div className=" dark:bg-gray-900 justify-center content-center text-center rounded p-3 w-full max-w-md">
                        <div className="flex  gap-4">
                            <div>

                                <h1 className=" text-xl text-gray-800  font-bold dark:text-white text-gray-200 mb-4"> Se connecter </h1>
                            </div>
                            
                        </div>
                        {/* <div className="flex gap-2">

                            <button className="w-full flex  rounded-lg border items-center justify-center bg-hidden dark:text-gray-100 py-2  mb-2"> Sign up with Google</button>
                            <button className="w-full flex rounded-lg border items-center justify-center bg-hidden dark:text-gray-100 py-2  mb-2"> Sign up with Apple</button>
                        </div> */}

                        {/* <div className="text-center text-gray-400 mb-4">or</div> */}
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <input
                            {...register("email", {
                              required: "veiller saisir",
                              pattern: "/^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/",
                            })}
                            type="email"
                            placeholder="Votre email"
                            className="w-full p-2 border-gray-300 rounded dark:bg-gray-800 bg-gray-100 dark:border-gray-600 border text-white mb-2"
                          />

                          <div className="relative w-full mb-4">
                            <input
                              {...register("password", {
                                required: "veiller saisir un mot de passe",
                                minLength: {
                                  value: 4,
                                  message: "veillez saisire u",
                                },
                              })}
                              type={showPassword ? "text" : "password"}
                              placeholder="Mot de passe"
                              className="w-full p-2 border-gray-300 rounded dark:bg-gray-800 bg-gray-100 dark:border-gray-600 border dark:text-gray-300 text-gray-700"
                            />

                            
                            <button
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              className="absolute right-3 top-2 text-gray-500 hover:text-gray-800 dark:hover:text-gray-200"
                            >
                              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                          </div>

                          <button
                            type="submit"
                            className="px-5 bg-blue-700 rounded text-white py-2"
                          >
                            Se Connecter
                          </button>
                        </form>
                        <p className="text-gray-400  dark:text-gray-200 mt-4 text-center">Vous n'avez pas de compte <a href="/mksp/register" className="text-blue-500">Inscrivez-vous ici.</a></p>
                    </div>

                </div>
            </div>


        </>
    )
}